import React from "react";

import { ListAttribute } from "../../ListAttribute";
import { AttributeComponent } from "../types";

export const LiteListFrameAttribute: AttributeComponent = ({
    dataSourceKey,
    recordId,
    attributeName,
    inline,
    title,
    hasBackgroundAttr = false,
    iconCode,
}) => (
    <ListAttribute
        {...{ dataSourceKey, recordId, attributeName, inline, title, hasBackgroundAttr, iconCode }}
    />
);
